// Load the YouTube IFrame API script once, shared by every player on the
// site (radio, event submissions). Resolves with the global YT namespace.
// Never resolves during SSR (nothing awaits it there) — module-scope code
// runs once per Node process on import, so it must not touch window/document.
const ytReady = typeof window === 'undefined' ? new Promise(() => {}) : new Promise((resolve) => {
    if (window.YT?.Player) {
        resolve(window.YT);
        return;
    }
    window.onYouTubeIframeAPIReady = () => resolve(window.YT);
    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
    }
});

export default ytReady;
